<template>
	<div class="patients">
		<md-card>
			<md-card-header>
				<div class="md-title">{{$t("admin.edit_news")}}</div>
				<div class="md-subhead">{{$t("admin.editnews_note")}}</div>
			</md-card-header>

			<md-card-content>
				<form novalidate @submit.stop.prevent="newStatus">
					<md-input-container>
						<label>{{$t("admin.title")}}</label>
						<md-input v-model="editor.title"></md-input>
					</md-input-container>
					<md-input-container>
						<label>{{$t("admin.content")}}</label>
						<md-textarea v-model="editor.text" maxlength="1500"></md-textarea>
					</md-input-container>
					<md-input-container>
						<label>{{$t("admin.image")}}</label>
						<md-file v-model="editor.image" id="fileInput"></md-file>
					</md-input-container>
					<div>
						<md-radio v-model="editor.type" md-value="general" class="md-primary">{{$t("admin.general")}}</md-radio>
						<md-radio v-model="editor.type" md-value="consultingChange" class="md-primary">{{$t("admin.change_appointment")}}</md-radio>
						<md-radio v-model="editor.type" md-value="assistance" class="md-primary">{{$t("admin.substitution")}}</md-radio>
					</div>
					<md-switch v-model="editor.published" class="md-primary">{{$t("admin.release")}}</md-switch>
					<md-button :disabled="loading" class="md-raised md-accent" type="submit">{{$t("admin.save")}}</md-button>
				</form>
			</md-card-content>
		</md-card>


		<section class="feed row">
			<div v-for="status of $store.state.feed" class="status col-md-4 col-xs-12">
				<md-card>
					<md-card-header>
						<div class="md-title">{{status.title}}</div>
						<div class="md-subhead">{{status.creator.name}} - {{status.createdAt | formatDate}}</div>
					</md-card-header>
					<md-card-content>
						<img v-if="status.image && status.image != 'null'" :src="status.image"/>
						{{status.text}}
					</md-card-content>
				</md-card>
			</div>
		</section>

	</div>
</template>

<script>
	import Api from '../../../generated'

	export default {
		data () {
			return {
				editor: {
					published: true,
					text: "",
					title: "",
					image: null,
					type: "general"
				},
				loading: false
			}
		},
		methods: {
			newStatus(){
				this.loading = true;
				Api.ApiClient.instance.createStatus(this.editor, (error, data, response) => {
					if (error) {
						console.error(error);
						this.loading = false;
					} else {
						console.log('API called successfully. Returned data: ');
						console.log(data);
						let statusId = data.data._id;

						if(document.getElementById('fileInput').files[0]){
							Api.ApiClient.instance.uploadAttachment(statusId, document.getElementById('fileInput').files[0], (error, data, response) => {
								if (error) {
									console.error(error);
									this.loading = false;
								} else {
									console.log(response);
									this.$bus.$emit('showToast','Sikeres mentés', 'info');
									this.reload();
								}
							});
						}else{
							this.$bus.$emit('showToast','Sikeres mentés', 'info');
							this.reload();
						}
					}
				});
			},
			reload(){
				// TODO: Re-enable loading animation when the code generator is fixed
				// Currently it fails on empty array during deserialization 
				//this.$bus.$emit('showLoading', true);
				this.editor = {
					published: true,
					text: "",
					title: "",
					image: null,
					type: "general"
				};
				Api.ApiClient.instance.getFeed({userCreated: true}, (error, data, response) => {
					if (error) {
						console.error(error);
					} else {
						console.log('API called successfully. Returned data: ' + data);
						this.$store.state.feed = data;
					}
					//this.$bus.$emit('showLoading', false);
				});
				this.loading = false;
			}
		},
		mounted () {
			this.reload();
		}
	}
</script>

<style scoped>
	.feed{
		margin-top: 8px;
	}
	.status{
		padding: 8px;
		display: flex;
	}
	.status .md-card{
		align-self: stretch;
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// FeedList.vue?030fb445